<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Amenities"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/amenities'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field :error-messages="errors" v-model="data.name" label="Nombre" solo hide-details="auto"
                  class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="profile_picture" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Icono</div>
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                  placeholder="Imagen de Icono" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture"></Upload>
                <v-img :src="icon_picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Upload from "@/components/Upload";
export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, Upload },
  computed: {
    ...mapState({
      status: state => state.Amenities.status
    })
  },
  data() {
    return {
      storeName: "Amenities",
      title: "Comodidad",
      icon_picture: "",
      filteredAttributes: ["icon_picture"],
      data: {
        name: "",
        description: "",
        icon_picture: null,
      }
    };
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.icon_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.icon_picture = fr.result;
      };
      fr.onerror = function () {
        self.icon_picture = "";
      };
      fr.readAsDataURL(this.data.icon_picture);
    }
  }
};
</script>
